module.exports = __webpack_public_path__ + "img/loader.53b54be7.gif";